export default __webpack_public_path__ + "static/media/icon-hazard-triangle.2d508807.svg";